


























import { Vue, Component, Prop } from 'vue-property-decorator';
@Component
export default class ToolBarEndpointSelectOpt extends Vue {
  @Prop() public data!: any;
  private show: boolean = false;
}
